module.exports = __webpack_public_path__ + "img/symbol_herzschloss.d56c438.jpg";